function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { string, number, bool, object } from 'prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import cn from 'classnames';
import { useIcon, useDesignTokens } from '../../hooks';

var Icon = function Icon(_ref) {
  var size = _ref.size,
      name = _ref.name,
      color = _ref.color,
      className = _ref.className,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      srOnly = _ref.srOnly,
      sizingUnit = _ref.sizingUnit,
      spinning = _ref.spinning,
      animationDuration = _ref.animationDuration,
      rotate = _ref.rotate,
      transition = _ref.transition,
      width = _ref.width,
      height = _ref.height,
      style = _ref.style;

  var _useIcon = useIcon(name),
      icon = _useIcon.icon,
      aspectRatio = _useIcon.aspectRatio;

  var _useDesignTokens = useDesignTokens(),
      colors = _useDesignTokens.colors;

  var inlineColor = null;

  if (['inherit', 'transparent'].includes(color)) {
    inlineColor = color;
  }

  if (color in colors) {
    inlineColor = colors[color];
  }

  var finalWidth = width || size;
  var finalHeight = height || size;

  if (width && !height) {
    finalHeight = width * aspectRatio;
  }

  if (height && !width) {
    finalWidth = height / aspectRatio;
  }

  var widthStyle = "".concat(finalWidth).concat(sizingUnit);
  var heightStyle = "".concat(finalHeight).concat(sizingUnit);
  return /*#__PURE__*/React.createElement("i", {
    className: cn(className, 'icon', spinning && 'icon--spinning'),
    style: _objectSpread({
      width: widthStyle,
      minWidth: widthStyle,
      height: heightStyle,
      minHeight: heightStyle,
      position: [top, right, bottom, left].some(function (x) {
        return x;
      }) ? 'absolute' : null,
      top: top ? "".concat(top, "px") : null,
      right: right ? "".concat(right, "px") : null,
      bottom: bottom ? "".concat(bottom, "px") : null,
      left: left ? "".concat(left, "px") : null,
      animationDuration: "".concat(animationDuration, "ms"),
      transform: rotate ? "rotate(".concat(rotate, "deg)") : null,
      transition: transition
    }, style)
  }, srOnly && /*#__PURE__*/React.createElement("span", {
    className: "sr-only" // More consistently accessible that the <title> element

  }, srOnly), /*#__PURE__*/React.createElement("svg", {
    className: "icon__svg",
    "aria-hidden": "true" // Prevent any text inside the SVG from being announced
    ,
    focusable: "false" // Fix IE focus bug
    ,
    style: {
      color: inlineColor,
      fill: inlineColor
    }
  }, icon));
};

Icon.defaultProps = {
  size: 16,
  srOnly: null,
  color: null,
  className: '',
  top: null,
  right: null,
  bottom: null,
  left: null,
  sizingUnit: 'px',
  spinning: false,
  animationDuration: 1000,
  rotate: 0,
  transition: null,
  width: null,
  height: null,
  style: null
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The size of the icon in pixels. */
  size: number,

  /** The name of one of the icons defined in the icons package. */
  name: string.isRequired,

  /** Text to be read by screen readers. */
  srOnly: string,

  /** The icon colour. */
  color: designTokenPropTypes.color,

  /** Additional class names to add to the component root. */
  className: string,

  /** Align the icon some number of pixels from the top if its container. */
  top: number,

  /** Align the icon some number of pixels from the right if its container. */
  right: number,

  /** Align the icon some number of pixels from the bottom if its container. */
  bottom: number,

  /** Align the icon some number of pixels from the left if its container. */
  left: number,

  /** The CSS sizing unit for width & height (e.g. px, em or %). */
  sizingUnit: string,

  /** Spin the icon. */
  spinning: bool,

  /** The duration of any animation in milliseconds. */
  animationDuration: number,

  /** The degrees by which to rotate for the icon. */
  rotate: number,

  /** Set a custom CSS transition. */
  transition: string,

  /** A more specific width for the icon. */
  width: number,

  /** A more specific height for the icon. */
  height: number,

  /** Custom inline style overrides. */
  style: object
} : {};
export default Icon;